import { useSearchParams } from "react-router-dom";
import useStorage from "../../../hooks/useStorage";
import { SUBSCRIPTION_URL_PARAMS } from "../const";
import { SubscriptionHashes } from "../@types";

const useSubscriptionHashes = (): {
  subscriptionHashes: SubscriptionHashes;
  shouldUseHashes: boolean;
  setSubscriptionHashes: (hashes: SubscriptionHashes) => void;
} => {
  const [searchParams] = useSearchParams();
  const shouldUseHashes = searchParams.has(SUBSCRIPTION_URL_PARAMS.HASHES);
  const [subscriptionHashes, setSubscriptionHashes] = useStorage(
    "subscription_hashes",
    []
  );

  return {
    subscriptionHashes: subscriptionHashes ?? [],
    shouldUseHashes,
    setSubscriptionHashes
  };
};

export default useSubscriptionHashes;
